import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { FormFieldComponent } from './form-field/form-field.component';
import { TextInputComponent } from './text-input/text-input.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { DateInputComponent } from './date-input/date-input.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { FileInputComponent } from './file-input/file-input.component';

@NgModule({
  declarations: [
    FormFieldComponent,
    TextInputComponent,
    SelectInputComponent,
    DateInputComponent,
    RadioGroupComponent,
    FileInputComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule],
  exports: [
    TextInputComponent,
    SelectInputComponent,
    DateInputComponent,
    RadioGroupComponent,
    FileInputComponent,
  ],
})
export class CoreInputsModule {}
